import React from 'react';
import dash_img from "../assets/images/man-with-laptop.png";
import ProposalLeads from "../ProposalLeads/ProposalLeads";
import Footer from '../Footer/Footer';

const companyProfiles = [

  {
    id: 1,
    logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
    title: "Veritis Group Inc.",
    leads: 120,
    impressions: 200,
    rating: 4.8,
    tagline: "Innovating the Future",
    servicesCount: 10,
    productCount: 5,
    verified: true,
  },

  {
    id: 2,
    logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
    title: "Wipro",
    leads: 90,
    impressions: 50,
    rating: 4.7,
    tagline: "Your Digital Partner",
    servicesCount: 8,
    productCount: 3,
    verified: false,
  },


  {
    id: 3,
    logo: "https://v.fastcdn.co/u/573f0666/64658906-0-zd-primary-logo.svg",
    title: "ZenDesk Solutions Inc.",
    leads: 120,
    rating: 4.5,
    impressions: 125,
    tagline: "Innovating the Future",
    servicesCount: 10,
    productCount: 5,
    verified: true,
  },



];

const NonCompanyProfile = () => {
  return (
<>
    <div className="js-pg-hg mt-5">
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="heading mb-4 pb-1">
            <h6 className="card-title text-primary mb-2">Welcome Madhav!</h6>
            <h4>Your Proposal</h4>
          </div>


      <ProposalLeads />


          <div className="row mb-5">
          <div class="col-sm-12">
          <div class="card shadow-sm rounded-4">
        <div class="d-flex align-items-center row">
          <div class="col-sm-8">
            <div class="card-body px-4 mx-2">
              <h5 class="card-title text-primary mb-3">Review a Company</h5>
              <p class="mb-6">Leaving a review helps Comapany leaders like you make a confident choice.</p>

              <a href="javascript:;" class="btn btn-primary">Write a Review</a>
            </div>
          </div>
          <div class="col-sm-4 text-center text-sm-left">
            <div class="card-body pb-0 px-0 px-md-6">
              <img src={dash_img} height="175" class="scaleX-n1-rtl" alt="View Badge User" />
            </div>
          </div>
          </div>
        </div>
      </div>
      </div>

        </div>
      </div>




    </div>
    </div>
    <Footer />
    </>
  );
};

export default NonCompanyProfile;
